/**
 * #49 문제 알리기: the last error code shown in this tab, so a report can
 * carry it. Codes only (E-…, HTTP_…); never record content.
 */
const KEY = "sobidogam:lastErrorCode";

export function rememberError(code: string) {
	try {
		window.sessionStorage.setItem(KEY, code.slice(0, 40));
	} catch {
		// Session storage can be blocked; the report just omits the line.
	}
}

export function lastErrorCode(): string | null {
	try {
		return window.sessionStorage.getItem(KEY);
	} catch {
		return null;
	}
}
